var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 0H4.375C3.21471 0 2.10186 0.460929 1.28139 1.28139C0.460929 2.10186 0 3.21471 0 4.375V15.625C0 16.7853 0.460929 17.8981 1.28139 18.7186C2.10186 19.5391 3.21471 20 4.375 20H15.625C16.7853 20 17.8981 19.5391 18.7186 18.7186C19.5391 17.8981 20 16.7853 20 15.625V4.375C20 3.21471 19.5391 2.10186 18.7186 1.28139C17.8981 0.460929 16.7853 0 15.625 0V0ZM18.75 15.625C18.75 16.4538 18.4208 17.2486 17.8347 17.8347C17.2486 18.4208 16.4538 18.75 15.625 18.75H4.375C3.54618 18.75 2.75139 18.4208 2.16532 17.8347C1.57925 17.2486 1.25 16.4538 1.25 15.625V4.375C1.25 3.54618 1.57924 2.75139 2.16532 2.16532C2.7514 1.57925 3.54618 1.25 4.375 1.25H15.625C16.4538 1.25 17.2486 1.57924 17.8347 2.16532C18.4207 2.7514 18.75 3.54618 18.75 4.375V15.625Z",
    fill: "#656565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 4.375H6.25C6.59515 4.375 6.875 4.72015 6.875 5V6.25C6.875 6.59515 6.59515 6.875 6.25 6.875H5C4.65485 6.875 4.375 6.52985 4.375 6.25V5C4.375 4.65485 4.65485 4.375 5 4.375Z",
    fill: "#656565"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.75H6.25C6.59515 8.75 6.875 9.09515 6.875 9.375V10.625C6.875 10.9701 6.59515 11.25 6.25 11.25H5C4.65485 11.25 4.375 10.9049 4.375 10.625V9.375C4.375 9.02985 4.65485 8.75 5 8.75Z",
    fill: "#656565"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 13.125H6.25C6.59515 13.125 6.875 13.4701 6.875 13.75V15C6.875 15.3451 6.59515 15.625 6.25 15.625H5C4.65485 15.625 4.375 15.2799 4.375 15V13.75C4.375 13.4049 4.65485 13.125 5 13.125Z",
    fill: "#656565"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 5H15.625V6.25H8.125V5Z",
    fill: "#656565"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 9.375H15.625V10.625H8.125V9.375Z",
    fill: "#656565"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 13.75H15.625V15H8.125V13.75Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconList);
export default __webpack_public_path__ + "static/media/icon-list.d8e2b9b81ead93c33cc08d7a7c26eb81.svg";
export { ForwardRef as ReactComponent };